import { render } from "./MediumSizedModal.vue?vue&type=template&id=30d0489c&scoped=true"
import script from "./MediumSizedModal.vue?vue&type=script&lang=js"
export * from "./MediumSizedModal.vue?vue&type=script&lang=js"

import "./MediumSizedModal.vue?vue&type=style&index=0&id=30d0489c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-30d0489c"]])

export default __exports__